<app-spinner-overlay></app-spinner-overlay>
<div>
  <header>
    <img [src]="temaService.logoPath" alt="Sostenibile" class="logo-path" />
  </header>
  <div *ngIf="isAnteprima" class="anteprima">Anteprima</div>
</div>
<div class="contenitore" *ngIf="!completato">
  <ng-scrollbar>
    <div class="contenuto">
      <app-compila-sintesi-sostenibilita
        [idSintesiSostenibilita]="idReportVsme"
        [esercizio]="undefined"
        [compilazione]="compilazione"
        *ngIf="compilazione"
        [salvaCompilazione]="salva"
        [isAnteprima]="isAnteprima"
        titolo="Report Vsme"
        [landingPage]="landingPage"
        (loading)="loading($event)"
        [temporaryToken]="temporaryToken"
        [isCompEsterna]="true"
      ></app-compila-sintesi-sostenibilita>
    </div>
  </ng-scrollbar>
</div>

<div class="compilato" *ngIf="completato">
  {{ messaggio }}
</div>
